import { render, staticRenderFns } from "./EmojiComponent.vue?vue&type=template&id=65b4b98a&scoped=true"
import script from "./EmojiComponent.vue?vue&type=script&lang=ts"
export * from "./EmojiComponent.vue?vue&type=script&lang=ts"
import style0 from "./EmojiComponent.vue?vue&type=style&index=0&id=65b4b98a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b4b98a",
  null
  
)

export default component.exports